import React, { FC } from 'react'

import { IconPaygProps } from './IconPayg.types'
import * as Styled from './styles/IconPayg.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPayg: FC<IconPaygProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPaygProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPaygProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M104 64H84V44a4 4 0 0 0-8 0v20H56a4 4 0 0 0 0 8h20v20a4 4 0 0 0 8 0V72h20a4 4 0 0 0 0-8zm-12 72H68a4 4 0 0 0 0 8h24a4 4 0 0 0 0-8z' />
        <path d='M112 0H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zm8 144a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPayg
